import {apiurl} from '@/services/config'

const API_URL = apiurl + '/backoffice/categories'

export const Kategoriservice = {
    listKategori,
    add,
    hapus,
    edit
}

async function listKategori (opt) {
    console.log(API_URL + `?sort=${opt.sortBy}&page=${opt.page}&size=${opt.itemsPerPage}&title=${opt.search}`)
    const response = await fetch(API_URL + `?sort=${opt.sortBy}&page=${opt.page-1}&size=${opt.itemsPerPage}&title=${opt.search}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}

async function add (postdata) {
    console.log(JSON.stringify({ postdata }.postdata), 'from add')
    return fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({ postdata }.postdata),
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(handleResponse)
      .then(data => {
        return data
      })
}

async function hapus (newsid) {
    return fetch(API_URL + '/' + newsid, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(handleResponse)
      .then(data => {
        return data
    })
}

async function edit (postdata) {
    // let dataMenu = []
    // postdata.menus.forEach(element => {
    //     element.id
    // });
    let data = {
        "title": postdata.title,
        "status": postdata.status,
        "showHome": postdata.showHome,
        "sort": postdata.sort,
        "menus": postdata.menus
    }
    return fetch(API_URL + '/' + postdata.id, {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(handleResponse)
      .then(data => {
        return data
    })
}

async function handleResponse (response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text)
        console.log(data, 'ini data')

        if (!data.success) {
            if (response.status === 401) {
                console.log("CALL LOGOUT");
                localStorage.setItem('token',null);
                localStorage.clear();
                location.reload(true)
            }
            const error = (data && data.msg) || response.statusText
            return Promise.reject(error)
        }
        return data
    })
}